import ImageIconDefault from "../../images/default_image_new_icon.svg";
import InActiveVideo from "../../images/Video_Inactive.svg";
import LinkIcon from "../../images/default_button_new_icon.svg";
import TableIcon from "../../images/default_table_tabs_new_icon.svg";
import TextIcon from "../../images/default_text_new_icon.svg";
import StructureActive from "../../images/active-structure-new-icon.svg";
import InActiveFormIcon from "../../images/default_forms_new_icon.svg";
import InActiveExtraIcon from "../../images/default_other_tools_new_icon.svg";
import InActiveForm from "../../images/default_forms_new_icon.svg";
// import InActivePopUpIcon from "../../images/customPopup/InActivePopUpBlockIcon.svg";
import ImageActive from "../../images/active_image_new_icon.svg";
import Structure from "../../images/default_structure_new_icon.svg";
import VideoInActive from "../../images/Video_Inactive.svg";
import VideoActive from "../../images/Video_Active.svg";
import InActivePopUpBlockIcon from "../../images/customPopup/InActivePopUpBlockIcon.svg";

const restrictDecimal = (that) => {
  that.focus(); //sets focus to element
  var val = that.value; //store the value of the element
  that.value = ""; //clear the value of the element
  that.value = val;
};
const blockContainer = document?.querySelector("#blocks");
const styleContainer = document?.querySelector("#stylesMangerBlock");
const traitsContainer = document?.querySelector("#traitBlock");
const backtoBlockSection = document?.querySelector("#backToBlocks");
const presentationType = window.localStorage.getItem("categoryType");

export const tableRowColumnDecimalRestriction = (selected) => {
  //setting of table row and column to restrict decimal value as row/column
  if (selected && selected.is("table")) {
    const decimalInputRow = document?.querySelector(
      ".gjs-trt-trait__wrp-rows input"
    );
    decimalInputRow?.addEventListener("keyup", function (event) {
      var that = this;
      restrictDecimal(that);
    });

    const decimalInputCol = document.querySelector(
      ".gjs-trt-trait__wrp-columns input"
    );
    decimalInputCol?.addEventListener("keyup", function (ev) {
      var that = this;
      restrictDecimal(that);
    });
  }
};

export const symbolRestrictModify = (selected) => {
  if (selected && selected.attributes.tagName=="sup") { 
    selected.set({
      editable: false,
      removable: false,
      draggable: false,
      droppable: false,
      selectable: false
    });
  }
}

export const linkComponent = (selected, elem) => {
  if (selected && selected.is("link")) {
    // onClick of hyperlink , focus should be on traits Block.
    document
      ?.getElementById("traitBlock")
      .scrollIntoView({ block: "end", inline: "nearest" });
  }
  if (elem.attributes.tagName === "a" && elem.attributes.type === "text" && elem.getTraits()[2].getName() === "data-slide-id") {

    elem.removeTrait("title");
    elem.removeTrait("id");
    elem.removeTrait("data-slide-id");

    elem.set("attributes", {
      href: "https://google.com",
      Title: "",
      target: "false",
    });
    elem.get("traits").add({
      type: "text",
      name: "Title",
      label: "Title",
      placeholder: "Enter title",
    });
    elem.get("traits").add({
      type: "href",
      name: "href",
      label: "URL",
    });
    elem.get("traits").add({
      type: "select",
      name: "target",
      label: "Target",
      default: "_self",
      options: [
        // Here the key is the `id` of the option
        { id: "_self", label: "This window", value: "_self" },
        { id: "_blank", label: "New window", value: "_blank" },
      ],
    });
  }
};

export const opacityFieldRestrictDecimal = () => {
  const opacityInput = document?.querySelector(
    ".gjs-sm-property__opacity .gjs-field-integer input"
  );
  opacityInput.addEventListener("keyup", function (e) {
    var that = this;
    that.focus(); //sets focus to element
    var val = that.value; //store the value of the element
    that.value = ""; //clear the value of the element
    that.value =
      val.indexOf(".") >= 0
        ? val.substr(0, val.indexOf(".")) + val.substr(val.indexOf("."), 3)
        : val;
    if (that.value > 1) {
      that.value = 1;
    }
  });
};

export const tableConfig = (editor) => {
  var defaultTable = editor.DomComponents.getType("table");
  var initialize = defaultTable.model.prototype.initialize;
  defaultTable.model.prototype.initialize = function () {
    initialize.apply(this, arguments);
    // table min row and column set to 1.. prevent from negative value
    this.get("traits").where({ name: "rows" })[0].set("min", 1);
    this.get("traits").where({ name: "columns" })[0].set("min", 1);
    this.get("traits").where({ name: "rows" })[0].set("max", 50);
    this.get("traits").where({ name: "columns" })[0].set("max", 50);
  };

  var defaultThead = editor.DomComponents.getType("thead");
  var initializeThead = defaultThead.model.prototype.initialize;
  defaultThead.model.prototype.initialize = function () {
    initializeThead.apply(this, arguments);
    this.set({
      style: { "font-weight": "bold" },
    });
  };

  var defaultTfoot = editor.DomComponents.getType("tfoot");
  var initializeTfoot = defaultTfoot.model.prototype.initialize;
  defaultTfoot.model.prototype.initialize = function () {
    initializeTfoot.apply(this, arguments);
    this.set({
      style: { "font-weight": "bold" },
    });
  };
};

export const hideModularContentForBodyTag = (component) => {
  if (component.attributes.tagName === "body" && presentationType === "1") {
    const propMod = document.querySelector(".gjs-sm-sector__modular_content");
    propMod?.classList.remove("d-block");
    propMod?.classList.add("d-none");
    const styleSectors = styleContainer?.firstElementChild.childNodes;
    const classesSelector = styleContainer?.lastElementChild.children;
    for (var i = 1; i < styleSectors?.length; i++) {
      styleSectors[i]?.classList.remove("d-block");
      styleSectors[i]?.classList.add("d-none");
    }
    styleSectors[4]?.classList.remove("d-none");
    styleSectors[4]?.classList.add("d-block");
    for (var i = 0; i < classesSelector.length; i++) {
      classesSelector[i].classList.remove("d-none");
      classesSelector[i].classList.add("d-block");
      classesSelector[i].classList.add("d-flex");
      if (i === classesSelector.length - 1) {
        classesSelector[i].classList.remove("d-flex");
      }
    }
    return;
  }
};

export const modularContentToggleShow = (
  component,
  tagNameForm,
  switchToggleDataRef,
  editor
) => {
  const attr = component.getAttributes();
  const styleSectors = styleContainer?.firstElementChild?.childNodes;
  const classesSelector = styleContainer?.lastElementChild?.children;
  const propMod = document.querySelector(".gjs-sm-sector__modular_content");
  const modularPropertyHide = () => {
    propMod.classList.remove("d-block");
    propMod.classList.add("d-none");
  };
  const modularPropertyShow = () => {
    propMod.classList.remove("d-none");
    propMod.classList.add("d-block");
  };
  if (attr.hasOwnProperty("modularBlock") && presentationType === "1") {
    if (
      component.attributes.name === "Row" &&
      switchToggleDataRef.current !== "classic"
      // && JSON.stringify(currentSlideRef?.current?.child) === "{}"
    ) {
      modularPropertyShow();
    }
    // propMod.classList.add("d-block");
    for (var i = 1; i < styleSectors.length; i++) {
      styleSectors[i].classList.remove("d-block");
      styleSectors[i].classList.add("d-none");
    }
    for (var i = 0; i < classesSelector.length; i++) {
      classesSelector[i].classList.remove("d-block");
      classesSelector[i].classList.add("d-none");
    }
  } else {
    if (editor.getSelected().attributes.name === "Row") {
      editor.getSelected().set({
        selectable: true,
        removable: true,
        draggable: true,
        copyable: true,
        resizable: true,
      });
    }
    //  propMod.classList.add("d-block");
    traitsContainer?.classList.remove("d-none");
    traitsContainer?.classList.add("d-block");
    //const allComp = editor.getComponents().models;
    const currentSelection = editor.getSelected();
    const modBlockApproveA = editor
      ?.getWrapper()
      .find("[modularblockindex='0']");
    const allComp =
      editor.getWrapper().attributes?.components?.models[0]?.attributes
        .components.models;
    let currentIndex = 0;
    let moduleAindex = 0;
    let referenceIndexComp = 0;
    for (i = 0; i < allComp?.length; i++) {
      if (
        allComp[i].attributes.name === "Row" &&
        allComp[i].__innerHTML().includes("Module A")
      ) {
        moduleAindex = i;
      }
      if (allComp[i] === currentSelection) {
        currentIndex = i;
      }
      if (
        allComp[i].attributes.name === "Row" &&
        allComp[i].__innerHTML().includes("Reference")
      ) {
        referenceIndexComp = i;
      }
    }
    if (component.attributes.tagName !== "body" && presentationType === "1") {
      for (var i = 1; i < styleSectors.length; i++) {
        styleSectors[i].classList.remove("d-none");
        styleSectors[i].classList.add("d-block");
      }
      if (component.attributes.tagName === "img") {
        styleSectors[3].classList.remove("d-block");
        styleSectors[3].classList.add("d-none");
      }
      if (component.attributes.type === "video") {
        styleSectors[3].classList.remove("d-block");
        styleSectors[3].classList.add("d-none");
        styleSectors[5].classList.remove("d-block");
        styleSectors[5].classList.add("d-none");
      }
      if (
        component.attributes.tagName === "table" ||
        component.attributes.type === "link" ||
        component.attributes.type === "tabs" ||
        component.attributes.type === "tab"
      ) {
        styleSectors[5].classList.remove("d-block");
        styleSectors[5].classList.add("d-none");
      }

      if (tagNameForm.includes(component.attributes.tagName)) {
        styleSectors[5].classList.remove("d-block");
        styleSectors[5].classList.add("d-none");
      }

      for (var i = 0; i < classesSelector.length; i++) {
        classesSelector[i].classList.remove("d-none");
        classesSelector[i].classList.add("d-block");
        classesSelector[i].classList.add("d-flex");
        if (i === classesSelector.length - 1) {
          classesSelector[i].classList.remove("d-flex");
        }
      }

      const showHideBlock = document.querySelector(".modularBlock-Content");
      const hideOptions = () => {
        showHideBlock.classList.remove("d-block");
        showHideBlock.classList.add("d-none");
      };
      const showOptions = () => {
        showHideBlock.classList.remove("d-none");
        showHideBlock.classList.add("d-block");
      };
      const getSelectedValue = document?.querySelectorAll(
        ".modularContent-custom label"
      );
      if (
        component.attributes.name === "Row" &&
        component.components().length === 1 &&
        component.components().models[0].attributes.name === "Cell" &&
        switchToggleDataRef.current !== "classic"
        // && JSON.stringify(currentSlideRef?.current?.child) === "{}"
      ) {
        const nestedRow = component
          .components()
          .models[0].collection.models[0].components().length;
        // console.log(nestedRow, component.parents().length);
        if (currentIndex < moduleAindex) {
          modularPropertyHide();
        } else if (
          currentIndex > referenceIndexComp &&
          referenceIndexComp > moduleAindex
        ) {
          modularPropertyHide();
        } else {
          if (nestedRow < 1 && component.parents().length < 3) {
            classesSelector[2].classList.remove("d-none");
            classesSelector[2].classList.add("d-block");
            modularPropertyShow();
            getSelectedValue[0].querySelector(
              "input[type=checkbox]"
            ).checked = false;
            hideOptions();
          }
        }
      } else {
        modularPropertyHide();
      }
    }
  }
};

export const trackDroppingComponent = (
  component,
  setVideoSelected,
  setExpandLeft,
  setExpandRight,
  editor
) => {
  if (component.attributes.type === "video") {
    setVideoSelected(true);
  } else {
    setVideoSelected(false);
  }
  let catchDrop = JSON.parse(window.localStorage.getItem("drop"));

  if (!catchDrop) {
    const ab = document.getElementsByClassName("gjs-block-categories")[0];
    const hideProperties = document.getElementsByClassName(
      "right-left-section-label"
    )[0];

    const hidePropertiesPannel =
      document.getElementsByClassName("propertiesBlock")[0];
    ab?.classList.add("collapse-column");
    ab?.classList.remove("expand-column");
    hideProperties?.classList.add("d-block");
    hideProperties?.classList.remove("d-none");
    hidePropertiesPannel?.classList.add("d-block");
    hidePropertiesPannel?.classList.remove("d-none");
    setExpandRight(261);
    setExpandLeft(261);
    editor.refresh();
  } else if (component.attributes.type === "image") {
   // document.querySelector(".custom-images").click();
    window.localStorage.setItem("drop", false);
    return;
    //editor.select(null);
  }
};

export const leftPanelBlocksHideShow = (editor, component, tagNameForm) => {
  // console.log('dd', component.attributes.tagName)
  let isStructureBlockVisible = false;
  backtoBlockSection?.classList?.remove("d-none");
  backtoBlockSection?.classList?.add("d-block");
  backtoBlockSection?.classList?.remove("test-block");
  editor.AssetManager.close();
  const hideStructureBlock = document?.querySelector("#hideStructure");
  hideStructureBlock?.classList.add("d-none");
  const hideStructureBlockgjs = document.querySelector(
    ".gjs-block-categories .gjs-blocks-c"
  );
  const structureBlock = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  ).firstChild;
  const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children[2];
    const VideoBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children[3];
    const blocks = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children;
    // console.log(a, 'hhgg')
  const TextBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children[1];
  const formBlock = document.querySelector(".gjs-block-categories")
    .childNodes[1];
  const hideText = document.querySelector(".gjs-block-categories")
    .childNodes[2];
  const TableBlock = document.querySelector(".custom-table")
  const structureBlockElem = document.querySelector(
    ".gjs-block-categories"
  ).firstChild;
   const structureBlockEle = document.querySelector(
    "#imageblockdiv"
  );
  if(component.attributes.tagName !== "img") {
    structureBlockEle.classList.remove("d-block")
    structureBlockEle.classList.add("d-none")
  }
  if (
    ImageBlock &&
    !ImageBlock.classList.contains("active-block") &&
    !tagNameForm.includes(component.attributes.tagName)
  ) {
    hideStructureBlockgjs.classList.remove("d-none");
    formBlock?.classList.add("d-none");
    hideText?.classList.add("d-none");
    // showText.classList.remove("active-block");
    if(component.attributes.tagName === "img") {
      isStructureBlockVisible = false;
    } else {
      isStructureBlockVisible = true;
    }
    const showDefaultForm = document.querySelector(".custom-forms");
    if (showDefaultForm) {
      showDefaultForm.style.background = "white";
      showDefaultForm.getElementsByClassName(
        "gjs-block__media"
      )[0].firstChild.src = InActiveForm;
      showDefaultForm.classList.remove("active-block");
    }
    const showDefaultLink = document.querySelector(".custom-link");
    if (showDefaultLink) {
      showDefaultLink.style.background = "white";
      showDefaultLink.getElementsByClassName(
        "gjs-block__media"
      )[0].firstChild.src = LinkIcon;
      showDefaultLink.classList.remove("active-block");
    }
    ImageBlock.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.classList.add("img-block");
    ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      ImageIconDefault;
    ImageBlock.classList.remove("active-block");

    TableBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      TableIcon;
    TableBlock.classList.remove("active-block");

    TextBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      TextIcon;
    TextBlock.classList.remove("active-block");
    const showDefaultExtra = document.querySelector(".custom-extra");
    if (showDefaultExtra) {
      showDefaultExtra.style.background = "white";
      showDefaultExtra.getElementsByClassName(
        "gjs-block__media"
      )[0].firstChild.src = InActiveExtraIcon;
      showDefaultExtra.classList.remove("active-block");
    }
  }

  if (
    ImageBlock &&
    ImageBlock.classList.contains("active-block") &&
    editor.getSelected().attributes.tagName !== "img"
  ) {
    hideStructureBlockgjs.classList.remove("d-none");
    structureBlock.classList.add("active-block");
    structureBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      StructureActive;
      isStructureBlockVisible = true;
    ImageBlock.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.classList.add("img-block");
    ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      ImageIconDefault;
    ImageBlock.classList.remove("active-block");
  }

  const popupBlock = document.querySelector(".custom-popup");
  if (popupBlock && popupBlock.classList.contains("active-block")) {
    // isStructureBlockVisible = true;
    // popupBlock.getElementsByClassName(
    //   "gjs-block__media"
    // )[0].firstChild.src = InActivePopUpIcon;
    // popupBlock.classList.remove("active-block");
  }

  if(isStructureBlockVisible) {
    structureBlock.classList.add("active-block");
    structureBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      StructureActive;
    structureBlockElem.classList.remove("d-none");
    structureBlockElem.classList.add("d-block");
    blocks[8]?.getElementsByClassName(
      "gjs-block__media"
      )[0].firstChild.classList.add("img-block");
      blocks[8].getElementsByClassName("gjs-block__media")[0].firstChild.src = InActivePopUpBlockIcon;
      blocks[8]?.classList.remove("active-block");
      VideoBlock.getElementsByClassName(
      "gjs-block__media"
      )[0].firstChild.classList.add("img-block");
      VideoBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
        VideoInActive;
      // VideoBlock.classList.add("d-none");
      VideoBlock.classList.remove("active-block");
  }
    if(component.attributes.tagName === "img") {
      ImageBlock.getElementsByClassName(
      "gjs-block__media"
      )[0].firstChild.classList.add("img-block");
      ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
        ImageActive;
      ImageBlock.classList.add("active-block");
      ImageBlock.classList.remove("d-none");
      structureBlock.classList.remove("active-block");
      // structureBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      //   Structure;
      structureBlockElem.classList.add("d-none");
      structureBlockElem.classList.remove("d-block");
      VideoBlock.getElementsByClassName(
      "gjs-block__media"
      )[0].firstChild.classList.add("img-block");
      VideoBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
        VideoInActive;
      // VideoBlock.classList.add("d-none");
      VideoBlock.classList.remove("active-block");
      blocks[8]?.getElementsByClassName(
      "gjs-block__media"
      )[0].firstChild.classList.add("img-block");
      blocks[8].getElementsByClassName("gjs-block__media")[0].firstChild.src = InActivePopUpBlockIcon;
      blocks[8]?.classList.remove("active-block");
      // ImageBlock.classList.remove("d-none");
    }
};

export const videoConfig = (editor) => {
  var defaultTVideo = editor.DomComponents.getType("video");
  var initializeVideo = defaultTVideo.model.prototype.initialize;
  defaultTVideo.model.prototype.initialize = function () {
    initializeVideo.apply(this, arguments);
    // console.log("video", this);
    const attrList = this.getAttributes();
    if (this.attributes.tagName === "iframe") {
      if (this.attributes.attributes.hasOwnProperty("src")) {
        if (
          this.attributes.videoId !== "" &&
          this.attributes.src !== "" &&
          this.attributes.attributes.src.split("/").reverse()[0] !== "?"
        ) {
          const video_Id = this.attributes.attributes.src
            .split("/")
            .reverse()[0];
          this.set({ videoId: video_Id });
        } else {
          this.set({ videoId: "" });
        }
      } else {
      }
    }
  };
};

export const defaultConfigForAllComp = (editor) => {
  var defaultType = editor.DomComponents.getType("default");
  var _initialize = defaultType.model.prototype.initialize;
  defaultType.model.prototype.initialize = function () {
    //chngs made for commonhyml
    //this.addAttributes({ nonCommonHtml:'nonCommon' })
    _initialize.apply(this, arguments);
    //set custom states for grapesjs selectors
    editor?.SelectorManager?.setStates([
      { name: "hover", label: "Hover" },
      { name: "active", label: "Click" },
    ]);
    if (
      this.attributes.attributes.type === "checkbox" &&
      (this.attributes.attributes.value === "M" ||
        this.attributes.attributes.value === "F")
    ) {
      this.set({ type: "radio" });
      const attr = this.getAttributes();
      attr["type"] = "radio";
      attr["name"] = "gender";
      this.setAttributes(attr);
    }
    if (this.attributes.type === "textarea") {
      this.set({ name: "Text Area" });
      // editor.selectAdd(editor.getWrapper());
    }
    if (this.attributes.tagName === "h1") {
      this.set({ name: "H1" });
    }
    if (this.attributes.tagName === "h2") {
      this.set({ name: "H2" });
    }
    if (this.attributes.tagName === "p") {
      this.set({ name: "P" });
    }
    //restrict Animation for tabs component
    if (
      this.attributes.type === "tab" ||
      this.attributes.type === "tabs" ||
      this.attributes.type === "tab-contents"
    ) {
      this.set({
        unstylable: [
          "transition",
          "transform",
          "perspective",
          "modular_content",
        ],
      });
    }
    if (this.attributes.type === "text") {
      this.set({ unstylable: ["modular_content"] });
    }
    //add generic trait to whole editor component
    let result =
      this.get("traits").where({ name: "data-slide-id" }).length === 0 &&
      this.attributes.tagName !== "body" &&
      this.attributes.name !== "Wrapper" &&
      this.attributes.type !== "link" &&
      this.attributes.type !== "popup-close-button" &&
      this.attributes.type !== "popup-trigger-button";
    if (result) {
      this.get("traits").add({
        type: "select",
        label: "Link To",
        name: "data-slide-id",
      });
      editor?.SelectorManager?.setState("");
    }
  };
};

export const onCompSelectConfig = (elem, editor) => {
  const hrefLinked = elem.attributes?.attributes["href"];
  const subslideAttached = elem.attributes?.attributes["data-slide-id"];
  const formTagname = [
    "input",
    "textarea",
    "button",
    "select",
    "form",
    "label",
  ];
  if (elem.attributes.tagName === "img") {
    elem.set({
      unstylable: ["modular_content", "typography"],
    });
  }
  //set state value bydefault State
  editor?.SelectorManager.setState("");
  //uncheck all global classes by default, if required user can check
  editor.SelectorManager.getAll().map((selector) => {
    selector.set({
      active: false,
    });
  });
  const generalSector = editor.StyleManager.getSector("general");

  if (elem.attributes.type === "video") {
    generalSector.set("open", false);
    /* editor.StyleManager.removeSector("animations");
          editor.StyleManager.removeSector("typography"); */
    elem.set({
      unstylable: [
        "font-style",
        "text-indent",
        "font-family",
        "font-size",
        "font-weight",
        "letter-spacing",
        "color",
        "line-height",
        "text-align",
        "text-decoration",
        "text-shadow",
        "transform",
        "transition",
        "perspective",
        "modular_content",
      ],
    });
  } else {
    generalSector.set("open", true);
  }
  if (elem.attributes.type === "image") {
    elem.set({
      unstylable: [
        "font-family",
        "font-size",
        "font-style",
        "text-indent",
        "font-weight",
        "letter-spacing",
        "color",
        "line-height",
        "text-align",
        "text-decoration",
        "text-shadow",
        "background",
        "background-image",
        "background-repeat",
        "background-position",
        "background-size",
        "background-attachment",
        "modular_content",
      ],
    });
  }
  if (elem.attributes.type === "link") {
    // if (elem.getTrait("href")) {
    //   elem.getTrait("href").set({
    //     label: "URL",
    //   });
    // }

    elem.set({
      unstylable: ["transform", "transition", "perspective", "modular_content"],
    });
    if (subslideAttached) {
      elem.removeTrait("href");
    }
    if (hrefLinked?.trim() !== "" && hrefLinked?.trim() !== undefined) {
      // elem.getTrait("href").set({
      //   label: "URL",
      // });
      //elem.removeTrait("data-slide-id");
    }
  }

  if (formTagname.includes(elem.attributes.tagName)) {
    elem.set({
      unstylable: ["transform", "transition", "perspective", "modular_content"],
    });
    elem.removeTrait("data-slide-id");
  }
};

export const removePopupDivLinkedToComp = (elem, editor) => {
  const attrList = elem.getAttributes();
  const dataId =
    elem.attributes.tagName === "img" ? attrList["ccid"] : attrList["id"];
  let wrapper = editor.getWrapper();

  if (!/^\d+$/.test(dataId)) {
    var ele = wrapper?.find(`[data-id= '${dataId}']`);

    if (ele?.length > 0) {
      var comp = editor.getComponents();
      comp.remove(ele);
    }
  }
}

export const removeCompSettingRetainDefault = (editor) => {
  blockContainer?.classList?.remove("d-none");
  blockContainer?.classList?.add("d-block");
  traitsContainer?.classList?.remove("d-block");
  traitsContainer?.classList?.add("d-none");
  backtoBlockSection?.classList?.add("d-none");
  backtoBlockSection?.classList?.remove("test-block");
  editor.AssetManager.close();
  const hideStructureBlock = document?.querySelector("#hideStructure");
  hideStructureBlock?.classList?.add("d-none");
  const blockElementsParent = document?.querySelector(
    ".gjs-block-categories"
  );
  const showStructureBlocks = blockElementsParent?.firstElementChild;
  const formsElemBlock = blockElementsParent?.childNodes[1];
  const TextElemBlock = blockElementsParent?.childNodes[2];
  let availableStructureParent = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  );
  const hideCustomLink = document.querySelector(".custom-link");
  if (hideCustomLink) {
    hideCustomLink?.classList?.remove("active-block");
    hideCustomLink.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = LinkIcon;
  }
  const hideCustomText = document.querySelector(".custom-text");
  if (hideCustomText) {
    hideCustomText.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = TextIcon;
    hideCustomText?.classList?.remove("active-block");
  }
  const hideCustomImage = document.querySelector(".custom-images");
  if (hideCustomImage) {
    hideCustomImage.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = ImageIconDefault;
    hideCustomImage?.classList?.remove("active-block");
  }
  const hideCustomTable = document.querySelector(".custom-table");
  if (hideCustomTable) {
    hideCustomTable?.classList.remove("active-block");
    hideCustomTable.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = TableIcon;
  }
  const hideCustomForm = document.querySelector(".custom-forms");
  if (hideCustomForm) {
    hideCustomForm?.classList.remove("active-block");
    hideCustomForm.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = InActiveFormIcon;
  }
  const hideCustomExtra = document.querySelector(".custom-extra");
  if (hideCustomExtra) {
    hideCustomExtra?.classList.remove("active-block");
    hideCustomExtra.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = InActiveExtraIcon;
  }

  formsElemBlock && formsElemBlock.classList.remove("d-block");
  formsElemBlock && formsElemBlock.classList.add("d-none");
  TextElemBlock && TextElemBlock.classList.remove("d-block");
  TextElemBlock && TextElemBlock.classList.add("d-none");
  const structureBlock =
    availableStructureParent && availableStructureParent.firstChild;
  if (structureBlock !== "undefined" && structureBlock !== null) {
    structureBlock.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.src = StructureActive;
    structureBlock.classList.add("active-block");
  }

  showStructureBlocks && showStructureBlocks.classList.remove("d-none");
  showStructureBlocks && showStructureBlocks.classList.add("d-block");
}

export const callbackOnDeselectOfComp = (component, setState, editor) => {
  const hideStructureBlock = document?.querySelector("#hideStructure");
  /*  if (component.attributes.tagName === "video" && currentComp.attributes.tagName === "img") {
    hideStructureBlock?.classList.add("d-block");
    } */
  //  debugger
  // console.log('888', component.attributes.tagName)
  if (component.attributes.tagName === "img") {
     
    let catchDrop = JSON.parse(window.localStorage.getItem("drop"));
      if(!catchDrop) {
      window.localStorage.setItem('drop', false);
      // console.log("8411111")
     setState(false);
      editor?.AssetManager?.close();

    }
  
   
  //c setState(false);
    hideStructureBlock?.classList.add("d-none");
    const hideStructureBlockgjs = document.querySelector(
      ".gjs-block-categories .gjs-blocks-c"
    );
    const structureBlock = document.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c"
    ).firstChild;
    const ImageBlock = document.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c"
    ).children[2];
    hideStructureBlockgjs.classList.remove("d-none");
    // hideStructureBlockgjs.classList.add("d-block");
    // structureBlock.classList.add("active-block");
    // structureBlock.getElementsByClassName(
    //   "gjs-block__media"
    // )[0].firstChild.src = StructureActive;
    ImageBlock.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.classList.add("img-block");
    // ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
    //   ImageActive;
    // ImageBlock.classList.add("active-block");
    const VideoBlock = document.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c"
    ).children[3];
    VideoBlock.getElementsByClassName(
      "gjs-block__media"
    )[0].firstChild.classList.add("img-block");
    VideoBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
      InActiveVideo;
    VideoBlock.classList.remove("active-block");

  }
  if(component.attributes.tagName === "video") {
    setState(false);
  }
}

export const resetRhsStyleValuesToDefault = (editor) => {
  if (!editor) return;

  editor.select?.(null);
  editor.SelectorManager?.setState?.("");
  editor.SelectorManager?.getAll?.()?.forEach((selector) => {
    selector.set({ active: false });
  });

  const applyDefaultsKeepRhsOpen = () => {
    // RHS stays visible — only values go back to defaults
    // (runs after component:toggled hide, so panel is shown again)
    const styleEl =
      document.querySelector("#stylesMangerBlock") || styleContainer;
    styleEl?.classList?.remove("d-none");
    styleEl?.classList?.add("d-block");

    const smRoot = document.getElementsByClassName("gjs-sm-sectors")[0];
    smRoot
      ?.getElementsByClassName("gjs-sm-sector__general")[0]
      ?.classList?.remove("d-none");
    smRoot
      ?.getElementsByClassName("gjs-sm-sector__typography")[0]
      ?.classList?.remove("d-none");

    const resetProp = (prop) => {
      if (!prop) return;
      try {
        const def = prop.get?.("default") ?? prop.get?.("defaults") ?? "";
        if (typeof prop.clear === "function") {
          prop.clear();
        }
        if (typeof prop.setValue === "function") {
          prop.setValue(def);
        } else {
          prop.set?.("value", def);
        }
      } catch (_) {}

      const subs =
        (typeof prop.getProperties === "function" && prop.getProperties()) ||
        prop.properties;
      if (subs?.forEach) subs.forEach(resetProp);
      else if (typeof subs?.each === "function") subs.each(resetProp);
    };

    const sectors = editor.StyleManager?.getSectors?.();
    const walkSectors = (sector) => {
      const props =
        (typeof sector.getProperties === "function" &&
          sector.getProperties()) ||
        sector.get?.("properties");
      if (props?.forEach) props.forEach(resetProp);
      else if (typeof props?.each === "function") props.each(resetProp);
    };
    if (sectors?.forEach) sectors.forEach(walkSectors);
    else if (typeof sectors?.each === "function") sectors.each(walkSectors);

    editor.StyleManager?.render?.();
    const preview = document.querySelector(".gjs-sm-property__color .sp-preview-inner");
    if (preview) preview.style.backgroundColor = "transparent";
  };

  requestAnimationFrame(applyDefaultsKeepRhsOpen);
  setTimeout(applyDefaultsKeepRhsOpen, 0);
};

export const hideGeneralAndTopographyForWrapper = (editor) => {
  const styleEl = document.querySelector("#stylesMangerBlock") || styleContainer;
  const traitsEl = document.querySelector("#traitBlock") || traitsContainer;

  if (editor.getSelected()) {
    if (editor.getSelected()?.attributes?.name === "Wrapper") {
      styleEl?.classList.add("d-block");
      const sm = document?.getElementsByClassName("gjs-sm-sectors")[0];
      sm.getElementsByClassName("gjs-sm-sector__general")[0].classList.add(
        "d-none"
      );
      // sm.getElementsByClassName(" gjs-sm-sector__dimension")[0].classList.add(
      //   "d-none"
      // );
      sm.getElementsByClassName("gjs-sm-sector__typography")[0].classList.add(
        "d-none"
      );
      // traitsContainer.classList.add("d-block");
    } else if (editor.getSelected()?.attributes?.name !== "Wrapper") {
      const sm = document?.getElementsByClassName("gjs-sm-sectors")[0];
      styleEl?.classList.remove("d-none");
      sm.getElementsByClassName("gjs-sm-sector__general")[0].classList.remove(
        "d-none"
      );
      // sm.getElementsByClassName(
      //   " gjs-sm-sector__dimension"
      // )[0].classList.remove("d-none");
      sm.getElementsByClassName(
        "gjs-sm-sector__typography"
      )[0].classList.remove("d-none");
      //  traitsContainer.classList.remove("d-none");
      styleEl?.classList.add("d-block");
    }
  } else {
    // Keep RHS open when nothing is selected (e.g. LHS library click)
    styleEl?.classList.remove("d-none");
    styleEl?.classList.add("d-block");
    traitsEl?.classList.remove("d-block");
    traitsEl?.classList.add("d-none");
  }
}